import "./avgCalculator.css";

function SemMarks({ semestername, onChange, obtained, max, error }) {
  return (
    <div className="avg-calc-semester-row">
      <label>{semestername}</label>
      <div className="avg-calc-input-in">
        <div className="avg-calc-input-container">
          <input type="text" placeholder="Obtained Marks" value={obtained} onChange={(e) => onChange(semestername,"obtained", e.target.value)} />
          {error.obtained && <p className="avg-calc-error-msg">{error.obtained}</p>}
          </div>        
        <div className="avg-calc-input-container">
          <input type="text" placeholder="Maximum Marks" value={max} onChange={(e) => onChange(semestername,"max", e.target.value)} />
          {error.max && <p className="avg-calc-error-msg">{error.max}</p>}
        </div>
      </div>
    </div>
  );
}

export default SemMarks;
